export enum MarketDefaultStatus {
  required = 'required',
  onByDefault = 'onByDefault',
  offByDefault = 'offByDefault',
}

export type ReminderItemState = {
  journeyId: string;
  name: string;
  sendDateDescription: string;
  sendTimeText: string;
  marketDefault: MarketDefaultStatus;
  enabled: boolean;
  isRequired: boolean;
  isEnabledByDefault: boolean;
  format: string;
  timeInHour?: number | null;
  isSms?: boolean;
  isWhatsapp?: boolean;
  isDisabledForMarket?: boolean;
  supportedMarkets?: string[];
};

export type ReminderScheduleState = {
  allRemindersEnabled: boolean;
  reminders: ReminderItemState[];
};
